import Index from '@/views/exhibitor/account/Index.vue';
import Edit from '@/views/exhibitor/account/Edit.vue';
import { auths, actors } from '@/router/options';

const routes: any[] = [
  {
    path: 'account',
    redirect: { name: 'exhibitor-account-edit', query: { page: 'top' } },
    component: Index,
    children: [
      {
        name: 'exhibitor-account-edit',
        path: 'edit',
        component: Edit,
        meta: {
          title: 'アカウント編集',
          actor: actors.exhibitor,
          auth: auths.required,
        },
      },
    ],
  },
];

export default {
  routes,
};
